import React from 'react';
import ListPage from '../../base/ListPage.js';
import APILXD from '../../../http/APILXD.js';
import {Modal, message, Popover, Descriptions, Image} from 'antd';
import TimeHelp from "../../../tool/TimeHelp";
import HttpTool from "../../../tool/HttpTool";
import styles from "./index.less";
import ModalBase from "../../../components/modalBase";
import UploadFile from "../../../components/upLoad/UploadFile";
import dayjs from "dayjs";
import ModalDelete from "../../../components/modalDelete/ModalDelete";
import Help from "../../../tool/Help";

const MB = new ModalBase()
const MD = new ModalDelete()

export default class RechargeSet extends ListPage {
  constructor(props) {
    super(props);
  }

  base_getListConfig() {
    return {
      table: {
        columns: this.getTableColumns(),
        url: APILXD.pricePackageGetList,
        otherParam: {
          productType: 'power_deposit'
        },
      },
      new: {
        defaultValue: '新增充值套餐',
        action: () => {
          this.add();
        }
      },
    }
  }

  getAddData(defaultData) {
    let defaultOption = {
      type: "input",
      ver: true,
      reg: /^[\S\s]{0,50}$/,
      verMessage: "请填写，最多50个字符",
      required: true,
    };
    let props = {
      colCount: 1,
      formItemLayout: {
        labelCol: {span: 4},
        wrapperCol: {span: 16, offset: 0},
      },
      parameterArr: [
        {
          ...defaultOption,
          field: "moneySet",
          name: "价格(元)",
          type: 'inputNumber',
          reg: (v) => {
            return typeof v === 'number' && v >= 0
          },
          verMessage: '请输入价格，0-999999',
          option: {
            precision: 2,
            defaultValue: defaultData?.money ? defaultData?.money / 100 : undefined,
            style: {width: '100%'},
          }
        },
        {
          ...defaultOption,
          field: "priceSet",
          name: "灵能(个)",
          type: 'inputNumber',
          reg: (v) => {
            return typeof v === 'number' && v >= 0
          },
          verMessage: '请输入灵能，0-999999',
          option: {
            precision: 2,
            defaultValue: defaultData?.price ? defaultData?.price / 100 : undefined,
            style: {width: '100%'},
          }
        },
        {
          ...defaultOption,
          field: "sort",
          name: "排序",
          type: 'inputNumber',
          required: false,
          reg: () => {
            return true
          },
          option: {
            style: {width: '100%'},
            min: 1,
            precision: 0,
            defaultValue: defaultData?.sort,
          }
        },
      ],
    };
    return {
      props,
      otherParam: null
    }
  }

  add(defaultValue) {
    let addData = this.getAddData(defaultValue);
    MB.show(
      {
        title: defaultValue ? "编辑充值套餐" : "新增充值套餐",
        okTitle: "确定",
        closeTitle: "取消",
        width: '480px'
      },
      addData.props
      ,
      {
        otherParam: defaultValue ? {
          _id: defaultValue._id,
          productType: 'power_deposit'
        } : {
          productType: 'power_deposit'
        },
        url: defaultValue ? APILXD.pricePackageEdit : APILXD.pricePackageAdd,
        beforeSubmit: (param) => {
          param.money = param.moneySet * 100;
          param.price = param.priceSet * 100;
          return true;
        },
        callBack: (state, msg) => {
          //添加成功回调
          state == 'success' && this._loadDataForNet();
        }
      });
  }

  /**
   *  列表数据配置
   */
  getTableColumns() {
    return [
      {
        title: '价格(元)',
        dataIndex: 'money',
        key: 'money',
        render: (text) => {
          return (text || 0)/100;
        }
      },
      {
        title: '灵能(个)',
        dataIndex: 'price',
        key: 'price',
        render: (text) => {
          return (text || 0)/100;
        }
      },
      {
        title: '排序',
        dataIndex: 'sort',
        key: 'sort',
        width: 90,
        render: (text) => {
          return text ?? '-'
        }
      },
      {
        title: '操作',
        width: 220,
        render: (text, record, index) => {
          return (
            <div>
              {
                this.powerConfig.Edit
                  ? <span onClick={() => {
                    this.add(record)
                  }} className={styles.btnEdit}>{"修改"}</span>
                  : null
              }
              {
                this.powerConfig.Delete
                  ? <span onClick={() => {
                    MD.show({
                        title: "提示",
                        okTitle: "确定",
                        closeTitle: "取消",
                      },
                      {}
                      ,
                      {
                        otherParam: {_id: record._id},
                        content: record.name,
                        tip: '确认删除该套餐吗？删除后用户将无法选择该金额充值。',
                        url: APILXD.pricePackageDel,
                        apiType: 'post',
                        callBack: (state) => {
                          //删除成功回调
                          if(state === "success"){
                            if(this.items?.length === 1 && this.state.page > 1){
                              //当前页的最后一条
                              this.setState({
                                page: this.state.page - 1
                              },()=>{
                                this._loadDataForNet();
                              })
                            }else{
                              this._loadDataForNet();
                            }
                          }
                        }
                      });
                  }} className={styles.btnDelete}>{"删除"}</span>
                  : null
              }
            </div>
          )
        }
      },
    ]
  }
}
